import * as _ from 'underscore'
import {OpLocationEquipment as OpLocationEquipmentNew} from './op-location-equipment'

export class OpLocationEquipment {
    endTime: Date
    idLocation: number
    idLocationEquipment: number
    idMeter: number
    opState: number
    serialNbr: number
    startTime: Date
    device: Object

    // TODO: Backward compatibility. Delete when we start using only rest api.
    constructor(opObject) {
        if (opObject.enD_TIME != null) this.endTime = new Date(opObject.enD_TIME)        
        else this.endTime = null
        this.idLocation = opObject.iD_LOCATION
        this.idLocationEquipment = opObject.iD_LOCATION_EQUIPMENT
        this.idMeter = opObject.iD_METER
        this.opState = opObject.opState
        this.serialNbr = opObject.seriaL_NBR
        this.startTime = new Date(opObject.starT_TIME)
        this.device = opObject._Device
    }

    // TODO: Backward compatibility. Delete when we start using only rest api.
    // Use it before save.
    toOpObject() {
        var opObject: any = {}

        // ANDRI: todo
        //opObject.END_TIME = this.endTime

        opObject.dynamicValues = {}
        opObject.enD_TIME = this.endTime      
        opObject.iD_LOCATION = this.idLocation 
        opObject.iD_LOCATION_EQUIPMENT = this.idLocationEquipment
        opObject.iD_METER = this.idMeter
        opObject.opState = this.opState
        opObject.seriaL_NBR = this.serialNbr
        opObject.starT_TIME = this.startTime
        opObject._Device = this.device
        //_Location        :        null
        //_Meter        :        null


        return opObject
    }

    static fromNewOpLocation(locationEquipment: OpLocationEquipmentNew) {
        var obj = new OpLocationEquipment({})

        obj.idLocation = locationEquipment.idLocation
        obj.idLocationEquipment = locationEquipment.idLocationEquipment
        obj.idMeter = locationEquipment.idMeter
        obj.serialNbr = locationEquipment.serialNbr
        obj.idMeter = locationEquipment.idMeter
        obj.startTime = locationEquipment.startTime
        obj.endTime = locationEquipment.endTime
        obj.opState = locationEquipment.opState
        obj.device =  _.clone(locationEquipment.device);
        
        (obj.device as any).dynamicValues = locationEquipment.device.dynamicValues.reduce((acc, dynamicValue) => {
            acc[dynamicValue.Key] = dynamicValue.Value
            return acc
        }, {})

        return obj
    }
}